var count = 0;
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
  setTimeout(function(){
var main_max_p=parseInt($('.main_cal').attr('main-max-p'));
var max_p=parseInt($('.main_cal').attr('data-max-p'));
 var min_p=parseInt($('.main_cal').attr('data-min-p'));
if (isNaN(min_p) == false && isNaN(max_p) ==true){
max_p =parseInt($('.main_cal').attr('main-max-p'));
}

var nanValue = NaN;
var min_p=parseInt($('.main_cal').attr('data-min-p'));
var price_check;
var main_chcek_p 
var flag = 0;
if(searchParams.indexOf("filter.v.price.gte=") >-1){
 flag= 1;
}
if(flag == 0){
	var pmdSliderValueRange = document.getElementById('pmd-slider-value-range');
	
	noUiSlider.create(pmdSliderValueRange, {
		start: [ 0,  main_max_p], // Handle start position
		connect: true, // Display a colored bar between the handles
		tooltips: [ wNumb({ decimals: 0 }), wNumb({ decimals: 0 }) ],
		format: wNumb({
			decimals: 0,
			thousand: '',
			postfix: '',
		}),
		range: { // Slider can select '0' to '100'
			'min': 0,
			'max': main_max_p
		}
	});
	
	var valueMax = document.getElementById('value-max'),
		valueMin = document.getElementById('value-min');
	var flag_check_p = 0
	// When the slider value changes, update the input and span
	pmdSliderValueRange.noUiSlider.on('update', function( values, handle ) {
		if ( handle ) {
       if(flag_check_p == 0){
          if(values[handle]<main_max_p){
        flag_check_p = flag_check_p+1;
          $('input[name="filter.v.price.lte"]').val(values[handle]);
          $('.check_box #check_price').trigger('click');
          }  
       }else{
          $('input[name="filter.v.price.lte"]').val(values[handle]);
          $('.check_box #check_price').trigger('click');
         }
    valueMax.innerHTML = values[handle];

		} else {
          if(flag_check_p == 0){
if(values[handle]>0){
  flag_check_p = flag_check_p +1;
      $('input[name="filter.v.price.gte"]').val(values[handle]);
     $('.check_box #check_price').trigger('click');
    }
          }else{
            $('input[name="filter.v.price.gte"]').val(values[handle]);
     $('.check_box #check_price').trigger('click');
     }
			valueMin.innerHTML = values[handle];
		}

	});
}else{
	// multiple handled with value 
	var pmdSliderValueRange = document.getElementById('pmd-slider-value-range');
	
	noUiSlider.create(pmdSliderValueRange, {
		start: [ min_p,  max_p], // Handle start position
		connect: true, // Display a colored bar between the handles
		tooltips: [ wNumb({ decimals: 0 }), wNumb({ decimals: 0 }) ],
		format: wNumb({
			decimals: 0,
			thousand: '',
			postfix: '',
		}),
		range: { // Slider can select '0' to '100'
			'min': 0,
			'max': main_max_p
		}
	});
	var flag_check_p =0;
	var valueMax = document.getElementById('value-max'),
		valueMin = document.getElementById('value-min');
	
	// When the slider value changes, update the input and span
	pmdSliderValueRange.noUiSlider.on('update', function( values, handle ) {
					if ( handle ) {
       if(flag_check_p == 0){
          if(values[handle]<max_p || values[handle]>max_p){
         flag_check_p = flag_check_p+1;
          $('input[name="filter.v.price.lte"]').val(values[handle]);
           $('.check_box #check_price2').trigger('click');
          }  
       }else{
          $('input[name="filter.v.price.lte"]').val(values[handle]);
           $('.check_box #check_price2').trigger('click');
         }
    valueMax.innerHTML = values[handle];

		} else {
          if(flag_check_p == 0){
if(values[handle]>min_p ||values[handle]<min_p){
  flag_check_p = flag_check_p +1;
      $('input[name="filter.v.price.gte"]').val(values[handle]);
     $('.check_box #check_price2').trigger('click');
    }
          }else{
            $('input[name="filter.v.price.gte"]').val(values[handle]);
    $('.check_box #check_price2').trigger('click');
     }
			valueMin.innerHTML = values[handle];
		}
    
	});	
}
/************ mobile slider ***********/
 var main_max_p=parseInt($('.main_cal').attr('main-max-p'));
var max_p=parseInt($('.main_cal').attr('data-max-p'));
 var min_p=parseInt($('.main_cal').attr('data-min-p'));
if (isNaN(min_p) == false && isNaN(max_p) ==true){
max_p =parseInt($('.main_cal').attr('main-max-p'));
}

var nanValue = NaN;
var min_p=parseInt($('.main_cal').attr('data-min-p'));
var price_check;
var main_chcek_p 
var flag2 = 0;
if(searchParams.indexOf("filter.v.price.gte=") >-1){
 flag2= 1;
}
if(flag2 == 0){
	var pmdSliderValueRange = document.getElementById('pmd-slider-value-range2');
	
	noUiSlider.create(pmdSliderValueRange, {
		start: [ 0,  main_max_p], // Handle start position
		connect: true, // Display a colored bar between the handles
		tooltips: [ wNumb({ decimals: 0 }), wNumb({ decimals: 0 }) ],
		format: wNumb({
			decimals: 0,
			thousand: '',
			postfix: '',
		}),
		range: { // Slider can select '0' to '100'
			'min': 0,
			'max': main_max_p
		}
	});
	
	var valueMax = document.getElementById('value-max2'),
		valueMin = document.getElementById('value-min2');
	var flag_check_p = 0
	// When the slider value changes, update the input and span
	pmdSliderValueRange.noUiSlider.on('update', function( values, handle ) {
		if ( handle ) {
       if(flag_check_p == 0){
          if(values[handle]<main_max_p){
        flag_check_p = flag_check_p+1;
          $('input[name="filter.v.price.lte"]').val(values[handle]);
           $('.check_box #check_price2').trigger('click');
          }  
       }else{
          $('input[name="filter.v.price.lte"]').val(values[handle]);
           $('.check_box #check_price2').trigger('click');
         }
    valueMax.innerHTML = values[handle];

		} else {
          if(flag_check_p == 0){
if(values[handle]>0){
  flag_check_p = flag_check_p +1;
      $('input[name="filter.v.price.gte"]').val(values[handle]);
     $('.check_box #check_price2').trigger('click');
    }
          }else{
            $('input[name="filter.v.price.gte"]').val(values[handle]);
     $('.check_box #check_price2').trigger('click');
     }
			valueMin.innerHTML = values[handle];
		}

	});
}else{

	// multiple handled with value 
  
	var pmdSliderValueRange = document.getElementById('pmd-slider-value-range2');
	
	noUiSlider.create(pmdSliderValueRange, {
		start: [ min_p,  max_p], // Handle start position
		connect: true, // Display a colored bar between the handles
		tooltips: [ wNumb({ decimals: 0 }), wNumb({ decimals: 0 }) ],
		format: wNumb({
			decimals: 0,
			thousand: '',
			postfix: '',
		}),
		range: { // Slider can select '0' to '100'
			'min': 0,
			'max': main_max_p
		}
	});
	
	var valueMax = document.getElementById('value-max2'),
		valueMin = document.getElementById('value-min2');
		var flag_check_p = 0
	// When the slider value changes, update the input and span
	pmdSliderValueRange.noUiSlider.on('update', function( values, handle ) {
			if ( handle ) {
       if(flag_check_p == 0){
          if(values[handle]<max_p || values[handle]>max_p){
         flag_check_p = flag_check_p+1;
          $('input[name="filter.v.price.lte"]').val(values[handle]);
           $('.check_box #check_price2').trigger('click');
          }  
       }else{
          $('input[name="filter.v.price.lte"]').val(values[handle]);
           $('.check_box #check_price2').trigger('click');
         }
    valueMax.innerHTML = values[handle];

		} else {
          if(flag_check_p == 0){
if(values[handle]>min_p ||values[handle]<min_p){
  flag_check_p = flag_check_p +1;
      $('input[name="filter.v.price.gte"]').val(values[handle]);
     $('.check_box #check_price2').trigger('click');
    }
          }else{
            $('input[name="filter.v.price.gte"]').val(values[handle]);
    $('.check_box #check_price2').trigger('click');
     }
			valueMin.innerHTML = values[handle];
		}
    
	});	
}
},1500);
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);

    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
      
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        
        /***** Collection page featured products slider ****/
        if($('.col-featured-mobile-slider').length > 0){
        $('.col-featured-mobile-slider').flickity({ cellAlign: 'left',
        contain: true,
        pageDots: false,
        wrapAround: false,
        adaptiveHeight: false,
        lazyLoad: true,
        watchCSS: true,
        arrowShape: 'M6.00002 12.5151L5.22224 11.7007L9.79632 7.02271H0.0740967V5.88634H9.79632L5.22224 1.20831L6.00002 0.393921L11.9259 6.45453L6.00002 12.5151Z',
        on: {
        ready: function() {
        $('.flickity-button svg').attr('viewBox','0 0 12 13');
        $('.flickity-button.flickity-prev-next-button svg path').removeAttr('transform');
        //console.log('Flickity is ready');
        }
        }               
        });
        }
  
        /***** Collection page featured products slider END HERE ****/
 
      });
setTimeout(function(){
 /************ mobile slider ***********/
 var main_max_p=parseInt($('.main_cal').attr('main-max-p'));
var max_p=parseInt($('.main_cal').attr('data-max-p'));
 var min_p=parseInt($('.main_cal').attr('data-min-p'));
if (isNaN(min_p) == false && isNaN(max_p) ==true){
max_p =parseInt($('.main_cal').attr('main-max-p'));
}

var nanValue = NaN;
var min_p=parseInt($('.main_cal').attr('data-min-p'));
var price_check;
var main_chcek_p 
var flag2 = 0;
if(url.indexOf("filter.v.price.gte=") >-1){
 flag2= 1;
}
if(flag2 == 0){
	var pmdSliderValueRange = document.getElementById('pmd-slider-value-range2');
	
	noUiSlider.create(pmdSliderValueRange, {
		start: [ 0,  main_max_p], // Handle start position
		connect: true, // Display a colored bar between the handles
		tooltips: [ wNumb({ decimals: 0 }), wNumb({ decimals: 0 }) ],
		format: wNumb({
			decimals: 0,
			thousand: '',
			postfix: '',
		}),
		range: { // Slider can select '0' to '100'
			'min': 0,
			'max': main_max_p
		}
	});
	
	var valueMax = document.getElementById('value-max2'),
		valueMin = document.getElementById('value-min2');
	var flag_check_p = 0
	// When the slider value changes, update the input and span
	pmdSliderValueRange.noUiSlider.on('update', function( values, handle ) {
					if ( handle ) {
       if(flag_check_p == 0){
          if(values[handle]<max_p || values[handle]>max_p){
         flag_check_p = flag_check_p+1;
          $('input[name="filter.v.price.lte"]').val(values[handle]);
           $('.check_box #check_price2').trigger('click');
          }  
       }else{
          $('input[name="filter.v.price.lte"]').val(values[handle]);
           $('.check_box #check_price2').trigger('click');
         }
    valueMax.innerHTML = values[handle];

		} else {
          if(flag_check_p == 0){
if(values[handle]>min_p ||values[handle]<min_p){
  flag_check_p = flag_check_p +1;
      $('input[name="filter.v.price.gte"]').val(values[handle]);
     $('.check_box #check_price2').trigger('click');
    }
          }else{
            $('input[name="filter.v.price.gte"]').val(values[handle]);
    $('.check_box #check_price2').trigger('click');
     }
			valueMin.innerHTML = values[handle];
		}

	});
}else{

	// multiple handled with value 
  
	var pmdSliderValueRange = document.getElementById('pmd-slider-value-range2');
	
	noUiSlider.create(pmdSliderValueRange, {
		start: [ min_p,  max_p], // Handle start position
		connect: true, // Display a colored bar between the handles
		tooltips: [ wNumb({ decimals: 0 }), wNumb({ decimals: 0 }) ],
		format: wNumb({
			decimals: 0,
			thousand: '',
			postfix: '',
		}),
		range: { // Slider can select '0' to '100'
			'min': 0,
			'max': main_max_p
		}
	});
	
	var valueMax = document.getElementById('value-max2'),
		valueMin = document.getElementById('value-min2');
		var flag_check_p = 0
	// When the slider value changes, update the input and span
	pmdSliderValueRange.noUiSlider.on('update', function( values, handle ) {
			if ( handle ) {
       if(flag_check_p == 0){
          if(values[handle]<max_p || values[handle]>max_p){
         flag_check_p = flag_check_p+1;
          $('input[name="filter.v.price.lte"]').val(values[handle]);
           $('.check_box #check_price2').trigger('click');
          }  
       }else{
          $('input[name="filter.v.price.lte"]').val(values[handle]);
           $('.check_box #check_price2').trigger('click');
         }
    valueMax.innerHTML = values[handle];

		} else {
          if(flag_check_p == 0){
if(values[handle]>min_p ||values[handle]<min_p){
  flag_check_p = flag_check_p +1;
      $('input[name="filter.v.price.gte"]').val(values[handle]);
     $('.check_box #check_price2').trigger('click');
    }
          }else{
            $('input[name="filter.v.price.gte"]').val(values[handle]);
    $('.check_box #check_price2').trigger('click');
     }
			valueMin.innerHTML = values[handle];
		}
    
	});	
}
},1500) 
  /********* mobile slider end *********/
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      document.getElementsByClassName('search_count')[0].innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
  var  params =  searchParams;
    if($.trim($('input[name="filter.v.price.gte"]').val()) == '' && $.trim($('input[name="filter.v.price.lte"]').val())== ''){
    var urlParts =searchParams;
    var params = new URLSearchParams(urlParts);
    params.delete('filter.v.price.gte');
    params.delete('filter.v.price.lte');
    params =params.toString();
    }
    

    FacetFiltersForm.renderPage(params, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
   
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
    
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
 form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);